import AutocompleteField from "./fields/AutocompleteField";
import DateField from "./fields/DateField";
import DateRangeField from "./fields/DateRangeField";
import NumberField from "./fields/NumberField";
import SelectField from "./fields/SelectField";
import TextField from "./fields/TextField";

/**
 * Maps a field `type` to its rendering component. Extend this map (or override
 * per instance via the `components` prop of SearchBar) to support new types.
 */
export const FIELD_REGISTRY = {
  text: TextField,
  number: NumberField,
  date: DateField,
  dateRange: DateRangeField,
  select: SelectField,
  autocomplete: AutocompleteField
};

export const resolveFieldComponent = (type, overrides = {}) => {
  const registry = {...FIELD_REGISTRY, ...overrides};
  const Component = registry[type];
  if (!Component) {
    console.warn(`[SearchBar] Tipo de campo desconocido: "${type}". Se usa "text" como fallback.`);
    return registry.text;
  }
  return Component;
};
